/*
 * Copyright (C) 2018 Bruno López Trigo
 * 
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.

 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.

 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import cloneDeep from "lodash/cloneDeep";
import {
  Typography,
  Drawer,
  Chip,
  IconButton,
  MenuItem,
  List,
  ListItem,
  ListItemText,
  Divider,
  Paper, Input, ExpansionPanel, ExpansionPanelSummary
} from "@material-ui/core";
import {
  getConfig,
  getDataset,
  getClassifications,
  updateAttributeConfig,
  updateAttributeNormalizedConfig,
  updateCategoricAttributeConfig,
  getClassificationsFuzzy,
  getClassificationsHtRules,
  addAttributeInterval,
  deleteAttributeInterval,
  downloadConfig,
  uploadTest,
  getTest,
  buildSvgFingramInstance,
  getClassificationsTreeFuzzy,
  addAttributeIntervalNormalized,
  deleteAttributeIntervalNormalized,
  updateConsequentConfig,
  buildFingramsTest,
  buildSvgFingramInstanceTest, getClassificationsRandomForest
} from "../global/API";
import {
  PanoramaFishEye,
  Menu,
  Close,
  SentimentVerySatisfied as High,
  SentimentSatisfied as Medium,
  SentimentVeryDissatisfied as Low,
  CloudUpload, ExpandMore
} from "@material-ui/icons";
import Slider from "@material-ui/lab/Slider";
import { Redirect } from "react-router-dom";
import CustomizedSnackbars from "../global/CustomizedSnackbars";
import Attribute from "./Attribute";
import Select from "react-virtualized-select";
import "react-select/dist/react-select.css";
import "react-virtualized/styles.css";
import "react-virtualized-select/styles.css";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import LockOpenIcon from "@material-ui/icons/LockOpenTwoTone";
import LockIcon from "@material-ui/icons/LockTwoTone";

const styles = theme => ({
  sideBar: {
    padding: 20,
  },

  configBar: {
    flexDirection: "row",
    justifyContent: "space-around",
    display: "-webkit-flex",
    webkitFlexWrap: "wrap",
    flexWrap: "wrap"
  },
  chipDataset: {
    color:"white",
    backgroundColor: "#283593",
    fontSize: 16,
    margin: 5,
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  upper: {
    textTransform: "uppercase",
    marginTop: 20
  },
  chipAttributes: {
    color:"white",
    fontSize: 16,
    backgroundColor: "#283593",
    margin: 5,
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  chipConsequents: {
    color:"white",
    fontSize: 16,
    backgroundColor: "#283593",
    margin: 5,
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  chipHigh: {
    color:"white",
    fontSize: 16,
    backgroundColor: "#4caf50",
    margin: 5,
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  chipMedium: {
    color:"white",
    fontSize: 16,
    backgroundColor: "#ffa000",
    margin: 5,
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  chipLow: {
    color:"white",
    fontSize: 16,
    backgroundColor: "#f4511e",
    margin: 5,
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  close: {
    float: "right"
  },
  select: {
    width: "100%",
    padding: 10,
    fontFamily: "Roboto"
  },
  selectDiv: {
    width: "90%",
    padding: 10
  },
  selected: {
    borderBottom: "solid",
    borderBottomColor: "#4caf50",
    width: "90%",
    padding: 10
  },
  selectLabel: {
    marginRight: 10,
    marginLeft: 10,
    marginTop: 5
  },
  percentage: {
    marginLeft: 10
  },
  button: {
    margin: 10,
    width: "100%"
  },
  buttonConfig: {
    color:"white",
    float: "left"
  },
  plainLogBox:{
    marginLeft:"auto",
    marginRight:"auto",
    marginTop:"20px",
    width:"50%",
    padding:"5px",
    backgroundColor: "#fafafa",
    border: "2px solid #283593",
    textAlign:"center",
    fontFamily:"Roboto"
  },
  plainLogBoxContenedor:{
    textAlign: "center",
  },
  panel:{
    color:"red",
  }
});

class ConfigurationPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      left: true,
      loading: true,
      errorsInstance: {},
      errorsAttributeName: {},
      errorsAttributeNameContent: {},
      errorsClassName : {},
      errorsClassNameContent:{},
      errorsPropertyName: {},
      errorsPropertyNameContent:{},
      errorsInterval: {},
      newConfig: true,
      newConfigClasses:true,
      newConfigAttributes:true,
      loadingButton: false,
      loadingButtonDelete: false,
      selected: "test",
      typeInstanceSelected:0,
      extendedCero :null,
      extendedOne :null,
      extendedTwo :null,
    };
    this.closeConfiguration = this.closeConfiguration.bind(this);
    this.changeAttributeName = this.changeAttributeName.bind(this);
    this.changeClassName = this.changeClassName.bind(this);
    this.changeAttributeValue = this.changeAttributeValue.bind(this);
    this.changePropertyName = this.changePropertyName.bind(this);
    this.changeCategoricValue = this.changeCategoricValue.bind(this);
    this.changeCategoricName = this.changeCategoricName.bind(this);
    this.classify = this.classify.bind(this);
    this.handleChangeSlider = this.handleChangeSlider.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.changeConfig = this.changeConfig.bind(this);
    this.changeInterval = this.changeInterval.bind(this);
    this.getConfig = this.getConfig.bind(this);
    this.getDataset = this.getDataset.bind(this);
    this.showNewInterval = this.showNewInterval.bind(this);
    this.changePropertyNameUser = this.changePropertyNameUser.bind(this);
    this.deleteInterval = this.deleteInterval.bind(this);
    this.downloadConfig = this.downloadConfig.bind(this);
    this.getFile = this.getFile.bind(this);
    this.uploadTest = this.uploadTest.bind(this);
    this.getTest = this.getTest.bind(this);
    this.handleChangePanel = this.handleChangePanel.bind(this);
    this.changeConfigAttributes = this.changeConfigAttributes.bind(this);
    this.changeConfigClasses = this.changeConfigClasses.bind(this);
    this.changeLock = this.changeLock.bind(this);
  }

  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    this.setState({
      error: false,
      success: false
    });
  };

  deleteInterval(event) {
    this.setState({
      loadingButtonDelete: true
    });
    debugger;
    if(this.props.algorithm === "FuzzyHoeffdingDecisionTree") {
      var response = deleteAttributeIntervalNormalized(
          this.state.config.dataset,
          this.state.config.attributes[event.currentTarget.name].id,
          event.currentTarget.id,
          this.props.language.id,
          this.props.token
      );

      if (response.error) {
        if (response.status === 401) {
          this.props.handleGlobalMessage(
              "error",
              this.props.language.labels[this.props.language.id].errorMessageUnauthorized
          );
          this.props.closeSession();
          this.setState({
            redirect: true
          });
        } else {
          this.setState({
            error: true,
            message: response.data
          });
        }
      } else {
        setTimeout(
            function () {
              this.getConfig();
              this.setState({loadingButtonDelete: false});
            }.bind(this),
            1000
        );
        this.props.handleGlobalMessage(
            "warning",
            this.props.language.labels[this.props.language.id].warningMessageChangeAttribute
        );
      }
    }else{
       response = deleteAttributeInterval(
          this.state.config.dataset,
          this.state.config.attributes[event.currentTarget.name].id,
          event.currentTarget.id,
          this.props.language.id,
          this.props.token
      );

      if (response.error) {
        if (response.status === 401) {
          this.props.handleGlobalMessage(
              "error",
              this.props.language.labels[this.props.language.id].errorMessageUnauthorized
          );
          this.props.closeSession();
          this.setState({
            redirect: true
          });
        } else {
          this.setState({
            error: true,
            message: response.data
          });
        }
      } else {
        setTimeout(
            function () {
              this.getConfig();
              this.setState({loadingButtonDelete: false});
            }.bind(this),
            1000
        );
      }
    }
  }

  async showNewInterval(event) {
    debugger
    this.setState({
      loadingButton: true
    });
    var config = this.state.config;
    if(this.props.algorithm === "FuzzyHoeffdingDecisionTree"){
      var leftValue =(( config.attributes[event.currentTarget.name].normalizedProperties[config.attributes[event.currentTarget.name].normalizedProperties.length-1].interval.right+config.attributes[event.currentTarget.name].normalizedProperties[config.attributes[event.currentTarget.name].normalizedProperties.length-1].interval.left)/2);
    var property = {
      type: "numericProp",
      name: "Name",
      id: config.attributes[event.currentTarget.name].normalizedProperties.length,
      interval: {
        left: leftValue,
        right: config.attributes[event.currentTarget.name].intervalNormalized.right
      }
    }
      var response = addAttributeIntervalNormalized(
          this.state.config.dataset,
          config.attributes[event.currentTarget.name].id,
          property,
          this.props.language.id,
          this.props.token
      );

      if (response.error) {
        if (response.status === 401) {
          this.props.handleGlobalMessage(
              "error",
              this.props.language.labels[this.props.language.id].errorMessageUnauthorized
          );
          this.props.closeSession();
          this.setState({
            redirect: true
          });
        } else {
          this.setState({
            error: true,
            message: response.data
          });
        }
      } else {
        setTimeout(
            function() {
              this.getConfig();
              this.setState({ loadingButton: false });
            }.bind(this),
            1000
        );
        this.props.handleGlobalMessage(
            "warning",
            this.props.language.labels[this.props.language.id].warningMessageChangeAttribute
        );
      }
    }else{
       property = {
        type: "numericProp",
        name: "Name",
        id: config.attributes[event.currentTarget.name].properties.length,
        interval: {
          left: config.attributes[event.currentTarget.name].interval.right,
          right: config.attributes[event.currentTarget.name].interval.right + 1
        }
      }
       response = addAttributeInterval(
          this.state.config.dataset,
          config.attributes[event.currentTarget.name].id,
          property,
          this.props.language.id,
          this.props.token
      );

      if (response.error) {
        if (response.status === 401) {
          this.props.handleGlobalMessage(
              "error",
              this.props.language.labels[this.props.language.id].errorMessageUnauthorized
          );
          this.props.closeSession();
          this.setState({
            redirect: true
          });
        } else {
          this.setState({
            error: true,
            message: response.data
          });
        }
      } else {
        setTimeout(
            function() {
              this.getConfig();
              this.setState({ loadingButton: false });
            }.bind(this),
            1000
        );
      }
    }


  }

  async componentDidMount() {
    Promise.all([this.getConfig(), this.getDataset()]).then(() => {
      this.setState({ loading: false });
    });
  }

  async getTest() {
    var response = await getTest(this.props.dataset, this.props.token);

    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
          "error",
          this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({
          redirect: true
        });
      } else {
        this.setState({
          selected: "train"
        });
      }
    } else {
      const labelsTestInstances = response.data.lines.map(
        (instance, index) => ({
          value: index,
          label: "Instance " + (index + 1)
        })
      );

      this.setState({
        instancesTest: response.data.lines,
        labelsTestInstances,
        selectedTestInstance: labelsTestInstances[0],
        instanceTestIndex: 0,
        instance: {
          attributes: response.data.lines[0].attributes,
          solution: response.data.lines[0].solution
        }
      });
      this.props.getMatrix("test");
      if(this.props.algorithm === "FuzzyHoeffdingDecisionTree" || this.props.algorithm === "FuzzyHoeffdingDecisionTree") {
        this.props.getSvgFingramTest();
        this.props.getLogFingramsTest();
      }
    }
  }

  async getConfig() {
    var response = await getConfig(
      this.props.dataset,
      this.props.language.id,
      this.props.token
    );

    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
          "error",
          this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({
          redirect: true
        });
      } else {
        this.setState({
          error: true,
          message: response.data
        });
      }
    } else {
      var maximo=0;
      for(var i=0;i<response.data.attributes.length;i++){
        if(response.data.attributes[i].name.length>maximo){
          maximo=response.data.attributes[i].name.length;
        }
      }
      console.log(response)
      this.setState(
        {
          maximo: maximo,
          config: response.data,
          isDefault:
            response.data.dataset === "beer" ||
            response.data.dataset === "glass" ||
            response.data.dataset === "wine" ||
            response.data.dataset === "iris" ||
            response.data.dataset === "flavia" ||
            response.data.dataset === "vehicle" ||
            response.data.dataset === "ACB" ||
            response.data.dataset === "PIMA" ||
            response.data.dataset === "OULAD" ||
            response.data.dataset === "bank" ,
          percentage: 5
        },
        async () => {
          this.getTest();
        }
      );
    }
  }

  async getDataset() {
    var response = await getDataset(this.props.dataset, this.props.token);

    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
          "error",
          this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({
          redirect: true
        });
      }
      this.setState({
        error: true,
        message: response.data
      });
    } else {
      const labelsInstances = response.data.lines.map((instance, index) => ({
        value: index,
        label: "Instance " + (index + 1)
      }));

      this.setState({
        instances: response.data.lines,
        labelsInstances,
        selectedInstance: labelsInstances[0],
        instanceIndex: 0,
        instance: {
          attributes: response.data.lines[0].attributes,
          solution: response.data.lines[0].solution
        }
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.language.id !== this.props.language.id) {
      this.getConfig();
    }
  }

  handleChange = event => {
    if (event !== null) {
      this.setState({
        selected: "train",
        instanceIndex: event.value.toString(),
        selectedInstance: event,
        instance: {
          attributes: this.state.instances[event.value].attributes,
          solution: this.state.instances[event.value].solution
        },
        userInstance: null,
      });
    }
  };

  handleChangeTest = event => {
    if (event !== null) {
      this.setState({
        selected: "test",
        instanceTestIndex: event.value.toString(),
        selectedTestInstance: event,
        instance: {
          attributes: this.state.instancesTest[event.value].attributes,
          solution: this.state.instancesTest[event.value].solution
        },
        userInstance: null
      });
    }
  };

  closeConfiguration() {
    this.setState({ left: false });
  }

  toggleDrawer = (side, open) => () => {
    this.setState({
      [side]: open
    });
  };

  changeAttributeValue(event) {
    var instance;
    var regex = /^-?[0-9]+\.?[0-9]*$/;

    var errorsInstance = this.state.errorsInstance;

    errorsInstance[event.target.id] = event.target.value.match(regex) === null;

    if (this.state.userInstance) {
      instance = this.state.userInstance;
    } else {
      instance = cloneDeep(this.state.instance);
    }

    instance.attributes[event.target.id].value = event.target.value;
    delete instance["solution"];

    this.setState({
      userInstance: instance,
      errorsInstance
    });
  }

  changeAttributeName(event) {

    var config = this.state.config;
    var maximo = (this.state.maximo+20)
    var regex =new RegExp("^[A-Za-z0-9 -_ñÑ]{3,"+maximo+"}$");
    var errorsAttributeName = this.state.errorsAttributeName;
    var errorsAttributeNameContent = this.state.errorsAttributeNameContent;
    if(event.target.value.match(regex) === null){
      var regex2 = /^[A-Za-z0-9 -_ñÑ]*$/;
      errorsAttributeName[event.target.id] =true;
      if(event.target.value.match(regex2) === null){
        errorsAttributeNameContent[event.target.id] = this.props.language.labels[this.props.language.id].errorMessageAttribute1
      }else if(event.target.value.length < 3 ){
        errorsAttributeNameContent[event.target.id] = this.props.language.labels[this.props.language.id].errorMessageAttribute2
      }else if(event.target.value.length > 100){
        errorsAttributeNameContent[event.target.id] = this.props.language.labels[this.props.language.id].errorMessageAttribute3
      }else{
        errorsAttributeNameContent[event.target.id] = this.props.language.labels[this.props.language.id].errorMessageAttribute4
      }
    }else{
      errorsAttributeName[event.target.id] =false;
    }
    config.attributes[event.target.id].name = event.target.value;

    this.setState({
      config,
      errorsAttributeName,
      newConfig: false,
      newConfigAttributes:false,
    });
  }

  changeClassName(event) {
    var config = this.state.config;
    console.log(config);
    var maximo = (this.state.maximo+20)
    var regex =new RegExp("^[A-Za-z0-9 -_ñÑ]{3,"+maximo+"}$");
    var errorsClassName = this.state.errorsClassName;
    var errorsClassNameContent = this.state.errorsClassNameContent;
    if(event.target.value.match(regex) === null){
      var regex2 = /^[A-Za-z0-9 -_]*$/;
      errorsClassName[event.target.id] =true;
      if(event.target.value.match(regex2) === null){
        errorsClassNameContent[event.target.id] = this.props.language.labels[this.props.language.id].errorMessageAttribute1
      }else if(event.target.value.length < 3 ){
        errorsClassNameContent[event.target.id] = this.props.language.labels[this.props.language.id].errorMessageAttribute2
      }else if(event.target.value.length > 100){
        errorsClassNameContent[event.target.id] = this.props.language.labels[this.props.language.id].errorMessageAttribute3
      }else{
        errorsClassNameContent[event.target.id] = this.props.language.labels[this.props.language.id].errorMessageAttribute4
      }
    }else{
      errorsClassName[event.target.id] =false;
    }
    config.consequents[event.target.id].name = event.target.value;

    this.setState({
      config,
      errorsClassName,
      newConfig: false,
      newConfigClasses:false,
    });
  }

  changePropertyName(event) {
    var config = this.state.config;
    var regex = /^[A-Za-z0-9 -_ñÑ]{3,100}$/;
    var errorsPropertyName = this.state.errorsPropertyName;
    var errorsPropertyNameContent = this.state.errorsPropertyNameContent;
    if (!errorsPropertyName[event.target.name]) {
      errorsPropertyName[event.target.name] = {};
    }
    if (!errorsPropertyNameContent[event.target.name]) {
      errorsPropertyNameContent[event.target.name] = {};
    }

    if(event.target.value.match(regex) === null){
      var regex2 = /^[A-Za-z0-9 -_]*$/;
      errorsPropertyName[event.target.name][event.target.id] =true;
      if(event.target.value.match(regex2) === null){
        errorsPropertyNameContent[event.target.name] = this.props.language.labels[this.props.language.id].errorMessageProperty1
      }else if(event.target.value.length<3 ){
        errorsPropertyNameContent[event.target.name] = this.props.language.labels[this.props.language.id].errorMessageProperty2
      }else if(event.target.value.length>100){
        errorsPropertyNameContent[event.target.name] = this.props.language.labels[this.props.language.id].errorMessageProperty3
      }else{
        errorsPropertyNameContent[event.target.name] = this.props.language.labels[this.props.language.id].errorMessageProperty4
      }
    }else{
      errorsPropertyName[event.target.name][event.target.id] =false;
    }
    if(this.props.algorithm !== "FuzzyHoeffdingDecisionTree"){
        config.attributes[event.target.name].properties[event.target.id].name =
        event.target.value
    }else{
      config.attributes[event.target.name].normalizedProperties[event.target.id].name =
       event.target.value
    }

    this.setState({
      config,
      errorsPropertyName,
      newConfig: false,
      newConfigAttributes:false,
    });
  }

  changeCategoricName(event) {
    var config = this.state.config;
    var regex = /^[A-Za-z0-9 -_]{2,100}$/;
    var errorsPropertyName = this.state.errorsPropertyName;

    if (!errorsPropertyName[event.target.name]) {
      errorsPropertyName[event.target.name] = {};
    }

    errorsPropertyName[event.target.name][event.target.id] =
      event.target.value.match(regex) === null;
    if(this.props.algorithm !== "FuzzyHoeffdingDecisionTree") {
      config.attributes[event.target.name].normalizedProperties[event.target.id].value =
          event.target.value;
    }else{
      config.attributes[event.target.name].properties[event.target.id].value =
          event.target.value;
    }

    this.setState({
      config,
      errorsPropertyName,
      newConfig: false,
      newConfigAttributes:false,
    });
  }

  changePropertyNameUser(event) {
    var interval = this.state.interval;
    var regex = /^[A-Za-z0-9 -_]{3,100}$/;
    var errorsPropertyName = this.state.errorsPropertyName;

    if (!errorsPropertyName[event.target.name]) {
      errorsPropertyName[event.target.name] = {};
    }

    errorsPropertyName[event.target.name][event.target.id] =
      event.target.value.match(regex) === null;

    interval.name = event.target.value;
    interval.id = this.state.config.attributes[
      event.target.name
    ].properties.length;

    this.setState({
      interval,
      errorsPropertyName
    });
  }

  changeInterval(event, side) {
    var config = this.state.config;
    var regex = /^-?[0-9]+\.?[0-9]*$/;

    var errorsInterval = this.state.errorsInterval;

    if (!errorsInterval[event.target.name]) {
      errorsInterval[event.target.name] = {};
    }

    errorsInterval[event.target.name][event.target.id] =
      event.target.value.match(regex) === null;
    if(this.props.algorithm === "FuzzyHoeffdingDecisionTree") {
      config.attributes[event.target.name].normalizedProperties[event.target.id].interval[
          side
          ] = event.target.value;
    }else{
      config.attributes[event.target.name].properties[event.target.id].interval[
          side
          ] = event.target.value;
    }
    if(this.props.algorithm==="FuzzyHoeffdingDecisionTree") {
      if (event.target.id === "0" && side === "left") {
        config.attributes[event.target.name].interval.left = event.target.value;
      } else if (
          event.target.id ===
          (
              config.attributes[event.target.name].normalizedProperties.length - 1
          ).toString() &&
          side === "right"
      ) {
        config.attributes[event.target.name].interval.right = event.target.value;
      }
    }else{
      if (event.target.id === "0" && side === "left") {
        config.attributes[event.target.name].interval.left = event.target.value;
      } else if (
          event.target.id ===
          (
              config.attributes[event.target.name].properties.length - 1
          ).toString() &&
          side === "right"
      ) {
        config.attributes[event.target.name].interval.right = event.target.value;
      }
    }

    this.setState({
      config,
      errorsInterval,
      newConfig: false,
      newConfigAttributes:false,
    });
  }

  changeCategoricValue(event) {
    var instance;

    if (this.state.userInstance) {
      instance = this.state.userInstance;
    } else {
      instance = cloneDeep(this.state.instance);
    }

    instance.attributes[event.target.name].value = event.target.value;
    delete instance["solution"];

    this.setState({
      userInstance: instance
    });
  }

  async classify() {
    var instance;
    var showError = false;

    if (this.state.userInstance) {
      instance = this.state.userInstance;
    } else {
      instance = this.state.instance;
    }
    var values = { values: {} };
    for (var i = 0; i < this.state.config.attributes.length; i++) {
      if (this.state.errorsInstance[i + 1]) {
        showError = true;
        break;
      }
      values.values[instance.attributes[i + 1].id] =
        instance.attributes[i + 1].value;
    }

    if (!this.state.userInstance) {
      values["solution"] = instance.solution;
    }
    console.log(values);
    if (!showError && this.props.algorithm !== "FURIA" && this.props.algorithm !== "FuzzyHoeffdingDecisionTree" && this.props.algorithm !=="RandomForest") {
      var response = await getClassifications(
        this.props.dataset,
        this.props.algorithm,
        this.props.language.id,
        values,
        this.state.percentage,
        this.props.token
      );

      if (response.error) {
        if (response.status === 401) {
          this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
          );
          this.props.closeSession();
          this.setState({
            redirect: true
          });
        } else {
          this.setState({
            error: true,
            message: response.data
          });
        }
      } else {
        this.setState({
          classifications: response.data,
          left: false
        });
        this.props.updateTree(response.data, values, this.state.percentage);
      }
    } else if (!showError && this.props.algorithm !== "FuzzyHoeffdingDecisionTree" && this.props.algorithm!=="RandomForest") {
      response = await getClassificationsFuzzy(
        this.props.dataset,
        this.props.algorithm,
        this.props.language.id,
        values,
        this.state.percentage,
        this.props.token,
      );

      if (response.error) {
        if (response.status === 401) {
          this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
          );
          this.props.closeSession();
          this.setState({
            redirect: true
          });
        } else {
          this.setState({
            error: true,
            message: response.data
          });
        }
      } else {
        this.props.changeComprobation();
        this.setState({
          classifications: response.data,
          left: false
        });
        this.props.updateRules(response.data, values, this.state.percentage);
        if (this.state.selected === "train") {
          response = await buildSvgFingramInstance(
              this.props.dataset,
              this.props.algorithm,
              this.props.token,
              this.state.instanceIndex
          );
          if (response.error) {
            if (response.status === 401) {
              this.props.handleGlobalMessage(
                  "error",
                  this.props.language.labels[this.props.language.id].errorMessageUnauthorized
              );
              this.props.closeSession();
              this.setState({
                loading: false,
                redirect: true
              });
            } else {
              this.setState({
                loading: false,
                error: true,
                message: response.data
              });
            }
          } else {
            this.setState({
              loading: false,
              ready: true,
            });
            this.props.changeInstanceFingrams(response.data,"train");
          }
        } else {
          response = await buildSvgFingramInstanceTest(
              this.props.dataset,
              this.props.algorithm,
              this.props.token,
              this.state.instanceIndex
          );
          if (response.error) {
            if (response.status === 401) {
              this.props.handleGlobalMessage(
                  "error",
                  this.props.language.labels[this.props.language.id].errorMessageUnauthorized
              );
              this.props.closeSession();
              this.setState({
                loading: false,
                redirect: true
              });
            } else {
              this.setState({
                loading: false,
                error: true,
                message: response.data
              });
            }
          } else {
            this.setState({
              loading: false,
              ready: true,
            });
            this.props.changeInstanceFingrams(response.data,"test");
          }

        }
      }
    }else if(!showError && this.props.algorithm==="RandomForest"){
      if(this.state.selected ==="train") {
         response = await getClassificationsRandomForest(
            this.props.dataset,
            this.props.algorithm,
            this.props.language.id,
            values,
            this.state.instanceIndex,
            this.props.token
        );
        if (response.error) {
          if (response.status === 401) {
            this.props.handleGlobalMessage(
                "error",
                this.props.language.labels[this.props.language.id].errorMessageUnauthorized
            );
            this.props.closeSession();
            this.setState({
              redirect: true
            });
          } else {
            this.setState({
              error: true,
              message: response.data
            });
          }
        } else {
          this.setState({
            messageRandomForest: response.data,
          });
        }
      }else{
         response = await getClassificationsRandomForest(
            this.props.dataset,
            this.props.algorithm,
            this.props.language.id,
            values,
            this.state.instanceTestIndex,
            this.props.token
        );
        if (response.error) {
          if (response.status === 401) {
            this.props.handleGlobalMessage(
                "error",
                this.props.language.labels[this.props.language.id].errorMessageUnauthorized
            );
            this.props.closeSession();
            this.setState({
              redirect: true
            });
          } else {
            this.setState({
              error: true,
              message: response.data
            });
          }
        } else {
          this.setState({
            messageRandomForest: response.data,
          });
        }
      }
    } else if(!showError){
      response = await getClassificationsHtRules(
          this.props.dataset,
          this.props.algorithm,
          this.props.language.id,
          values,
          this.state.percentage,
          this.props.token
      );

      if (response.error) {
        if (response.status === 401) {
          this.props.handleGlobalMessage(
              "error",
              this.props.language.labels[this.props.language.id].errorMessageUnauthorized
          );
          this.props.closeSession();
          this.setState({
            redirect: true
          });
        } else {
          this.setState({
            error: true,
            message: response.data
          });
        }
      } else {
        this.setState({
          classifications: response.data,
          left: false
        });
        this.props.updateRules(response.data, values, this.state.percentage);
        response = await getClassificationsTreeFuzzy(
            this.props.dataset,
            this.props.algorithm,
            this.props.language.id,
            values,
            this.state.percentage,
            this.props.token
        );

        if (response.error) {
          if (response.status === 401) {
            this.props.handleGlobalMessage(
                "error",
                this.props.language.labels[this.props.language.id].errorMessageUnauthorized
            );
            this.props.closeSession();
            this.setState({
              redirect: true
            });
          } else {
            this.setState({
              error: true,
              message: response.data
            });
          }
        } else {
          this.setState({
            classifications: response.data,
            left: false
          });
        }
        this.props.changeComprobation();
          this.props.updateTree(response.data, values, this.state.percentage);
          if(this.state.selected === "train") {
            response = await buildSvgFingramInstance(
                this.props.dataset,
                this.props.algorithm,
                this.props.token,
                this.state.instanceIndex
            );
            if (response.error) {
              if (response.status === 401) {
                this.props.handleGlobalMessage(
                    "error",
                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                );
                this.props.closeSession();
                this.setState({
                  loading: false,
                  redirect: true
                });
              } else {
                this.setState({
                  loading: false,
                  error: true,
                  message: response.data
                });
              }
            } else {
              this.setState({
                loading: false,
                ready: true,
              });
              this.props.changeInstanceFingrams(response.data,"train");
            }
          }else{
            response = await buildSvgFingramInstanceTest(
                this.props.dataset,
                this.props.algorithm,
                this.props.token,
                this.state.instanceIndex
            );
            if (response.error) {
              if (response.status === 401) {
                this.props.handleGlobalMessage(
                    "error",
                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                );
                this.props.closeSession();
                this.setState({
                  loading: false,
                  redirect: true
                });
              } else {
                this.setState({
                  loading: false,
                  error: true,
                  message: response.data
                });
              }
            } else {
              this.setState({
                loading: false,
                ready: true,
              });
              this.props.changeInstanceFingrams(response.data,"test");
            }
          }
      }

    }else{
      this.setState({
        error: true,
        message: "Wrong instance format, please check fields"
      });
    }
  }

  getFile(event) {
    var reader = new FileReader();
    reader.onload = async event => {
      var obj;
      var regexName = /^[A-Za-z0-9 -_]{3,100}$/;
      var regexCategoric = /^[A-Za-z0-9 -_]{2,100}$/;
      var regexInterval = /^-?[0-9]+\.?[0-9]*$/;

      var errorsAttributeName = this.state.errorsAttributeName;
      var errorsPropertyName = this.state.errorsPropertyName;
      var errorsInterval = this.state.errorsInterval;

      try {
        obj = JSON.parse(event.target.result);
      } catch (er) {
        this.setState({
          error: true,
          message: "Wrong config format"
        });
        return;
      }

      if (obj.dataset !== this.state.config.dataset) {
        this.setState({
          error: true,
          message: "Wrong config, dataset names don't match"
        });
        return;
      }
      if (obj.attributes.length !== this.state.config.attributes.length) {
        this.setState({
          error: true,
          message: "Wrong config, attributes don't match"
        });
        return;
      }
      if (obj.consequents.length !== this.state.config.consequents.length) {
        this.setState({
          error: true,
          message: "Wrong config, consequents don't match"
        });
        return;
      }

        if(this.props.algorithm==="FuzzyHoeffdingDecisionTree") {
          for (var i = 0; i < this.state.config.attributes.length; i++) {
            if (
                (!obj.attributes[i].type === "numericAtt" &&
                    !obj.attributes[i].type === "categoricAtt") ||
                !obj.attributes[i].id ||
                !obj.attributes[i].name ||
                !obj.attributes[i].normalizedProperties
            ) {
              this.setState({
                error: true,
                message: "Wrong config, attribute missing information"
              });
              return;
            }

            errorsAttributeName[i] =
                obj.attributes[i].name.match(regexName) === null;

            if (obj.attributes[i].id !== this.state.config.attributes[i].id) {
              this.setState({
                error: true,
                message:
                    "Wrong config, attribute " +
                    this.state.config.attributes[i].id +
                    " not found"
              });
              return;
            }
            if (obj.attributes[i].normalizedProperties.length === 0) {
              this.setState({
                error: true,
                message:
                    "Wrong config, attribute " +
                    this.state.config.attributes[i].id +
                    " must have properties"
              });
              return;
            }
          for (var j = 0; j < obj.attributes[i].normalizedProperties.length; j++) {
            if (obj.attributes[i].type === "numericAtt") {
              if (
                  (!obj.attributes[i].normalizedProperties[j].type === "categoricProp" &&
                      !obj.attributes[i].normalizedProperties[j].type === "numericProp") ||
                  !obj.attributes[i].normalizedProperties[j].name ||
                  obj.attributes[i].normalizedProperties[j].id === undefined ||
                  !obj.attributes[i].normalizedProperties[j].interval
              ) {
                this.setState({
                  error: true,
                  message:
                      "Wrong config, invalid properties for " +
                      obj.attributes[i].id +
                      " attribute"
                });
                return;
              }

              if (!errorsPropertyName[i]) {
                errorsPropertyName[i] = {};
              }
              errorsPropertyName[i][j] =
                  obj.attributes[i].normalizedProperties[j].name.match(regexName) === null;

              if (
                  obj.attributes[i].normalizedProperties[j].interval.left === undefined ||
                  obj.attributes[i].normalizedProperties[j].interval.right === undefined
              ) {
                this.setState({
                  error: true,
                  message:
                      "Wrong config, invalid interval for property " +
                      obj.attributes[i].normalizedProperties[j].id +
                      " at " +
                      obj.attributes[i].id +
                      " attribute"
                });
                return;
              }
              if (
                  !obj.attributes[i].interval ||
                  obj.attributes[i].interval.left === undefined ||
                  obj.attributes[i].interval.right === undefined
              ) {
                this.setState({
                  error: true,
                  message:
                      "Wrong config, invalid interval for attribute " +
                      obj.attributes[i].id
                });
                return;
              }

              if (!errorsInterval[i]) {
                errorsInterval[i] = {};
              }

              errorsInterval[i][j] =
                  obj.attributes[i].normalizedProperties[j].interval.left
                      .toString()
                      .match(regexInterval) === null ||
                  obj.attributes[i].normalizedProperties[j].interval.right
                      .toString()
                      .match(regexInterval) === null;

              if (j === 0) {
                obj.attributes[i].interval.left =
                    obj.attributes[i].normalizedProperties[j].interval.left;
              } else if (j === obj.attributes[i].normalizedProperties.length - 1) {
                obj.attributes[i].interval.right =
                    obj.attributes[i].normalizedProperties[j].interval.right;
              }

              if (!this.state.config.attributes[i].normalizedProperties[j]) {
                var prop = this.state.config.attributes[i].normalizedProperties[
                this.state.config.attributes[i].normalizedProperties.length - 1
                    ];
                prop.interval.left = prop.interval.right;
                prop.interval.right += 1;

                await addAttributeInterval(
                    this.state.config.dataset,
                    this.state.config.attributes[i].id,
                    prop,
                    this.props.language.id,
                    this.props.token
                );
              }
            } else {
              if (
                  !obj.attributes[i].normalizedProperties[j].type ||
                  !obj.attributes[i].normalizedProperties[j].name ||
                  !obj.attributes[i].normalizedProperties[j].value
              ) {
                this.setState({
                  error: true,
                  message:
                      "Wrong config, invalid properties for " +
                      obj.attributes[i].id +
                      " attribute"
                });
                return;
              }

              if (!errorsPropertyName[i]) {
                errorsPropertyName[i] = {};
              }
              errorsPropertyName[i][j] =
                  obj.attributes[i].normalizedProperties[j].name.match(regexCategoric) ===
                  null;
            }
          }
          for (
              j = 0;
              j < this.state.config.attributes[i].normalizedProperties.length;
              j++
          ) {
            if (!obj.attributes[i].normalizedProperties[j]) {
              console.log(
                  await deleteAttributeInterval(
                      this.state.config.dataset,
                      this.state.config.attributes[i].id,
                      j,
                      this.props.language.id,
                      this.props.token
                  )
              );
            }
          }
        }
        }else{
          for ( i = 0; i < this.state.config.attributes.length; i++) {
            if (
                (!obj.attributes[i].type === "numericAtt" &&
                    !obj.attributes[i].type === "categoricAtt") ||
                !obj.attributes[i].id ||
                !obj.attributes[i].name ||
                !obj.attributes[i].properties
            ) {
              this.setState({
                error: true,
                message: "Wrong config, attribute missing information"
              });
              return;
            }

            errorsAttributeName[i] =
                obj.attributes[i].name.match(regexName) === null;

            if (obj.attributes[i].id !== this.state.config.attributes[i].id) {
              this.setState({
                error: true,
                message:
                    "Wrong config, attribute " +
                    this.state.config.attributes[i].id +
                    " not found"
              });
              return;
            }
            if (obj.attributes[i].properties.length === 0) {
              this.setState({
                error: true,
                message:
                    "Wrong config, attribute " +
                    this.state.config.attributes[i].id +
                    " must have properties"
              });
              return;
            }
            for ( j = 0; j < obj.attributes[i].properties.length; j++) {
              if (obj.attributes[i].type === "numericAtt") {
                if (
                    (!obj.attributes[i].properties[j].type === "categoricProp" &&
                        !obj.attributes[i].properties[j].type === "numericProp") ||
                    !obj.attributes[i].properties[j].name ||
                    obj.attributes[i].properties[j].id === undefined ||
                    !obj.attributes[i].properties[j].interval
                ) {
                  this.setState({
                    error: true,
                    message:
                        "Wrong config, invalid properties for " +
                        obj.attributes[i].id +
                        " attribute"
                  });
                  return;
                }

                if (!errorsPropertyName[i]) {
                  errorsPropertyName[i] = {};
                }
                errorsPropertyName[i][j] =
                    obj.attributes[i].properties[j].name.match(regexName) === null;

                if (
                    obj.attributes[i].properties[j].interval.left === undefined ||
                    obj.attributes[i].properties[j].interval.right === undefined
                ) {
                  this.setState({
                    error: true,
                    message:
                        "Wrong config, invalid interval for property " +
                        obj.attributes[i].properties[j].id +
                        " at " +
                        obj.attributes[i].id +
                        " attribute"
                  });
                  return;
                }
                if (
                    !obj.attributes[i].interval ||
                    obj.attributes[i].interval.left === undefined ||
                    obj.attributes[i].interval.right === undefined
                ) {
                  this.setState({
                    error: true,
                    message:
                        "Wrong config, invalid interval for attribute " +
                        obj.attributes[i].id
                  });
                  return;
                }

                if (!errorsInterval[i]) {
                  errorsInterval[i] = {};
                }

                errorsInterval[i][j] =
                    obj.attributes[i].properties[j].interval.left
                        .toString()
                        .match(regexInterval) === null ||
                    obj.attributes[i].properties[j].interval.right
                        .toString()
                        .match(regexInterval) === null;

                if (j === 0) {
                  obj.attributes[i].interval.left =
                      obj.attributes[i].properties[j].interval.left;
                } else if (j === obj.attributes[i].properties.length - 1) {
                  obj.attributes[i].interval.right =
                      obj.attributes[i].properties[j].interval.right;
                }

                if (!this.state.config.attributes[i].properties[j]) {
                   prop = this.state.config.attributes[i].properties[
                  this.state.config.attributes[i].properties.length - 1
                      ];
                  prop.interval.left = prop.interval.right;
                  prop.interval.right += 1;

                  await addAttributeInterval(
                      this.state.config.dataset,
                      this.state.config.attributes[i].id,
                      prop,
                      this.props.language.id,
                      this.props.token
                  );
                }
              } else {
                if (
                    !obj.attributes[i].properties[j].type ||
                    !obj.attributes[i].properties[j].name ||
                    !obj.attributes[i].properties[j].value
                ) {
                  this.setState({
                    error: true,
                    message:
                        "Wrong config, invalid properties for " +
                        obj.attributes[i].id +
                        " attribute"
                  });
                  return;
                }

                if (!errorsPropertyName[i]) {
                  errorsPropertyName[i] = {};
                }
                errorsPropertyName[i][j] =
                    obj.attributes[i].properties[j].name.match(regexCategoric) ===
                    null;
              }
            }
            for (
                j = 0;
                j < this.state.config.attributes[i].properties.length;
                j++
            ) {
              if (!obj.attributes[i].properties[j]) {
                console.log(
                    await deleteAttributeInterval(
                        this.state.config.dataset,
                        this.state.config.attributes[i].id,
                        j,
                        this.props.language.id,
                        this.props.token
                    )
                );
              }
          }
        }
      }
      this.setState({
        errorsAttributeName,
        errorsPropertyName,
        errorsInterval,
        config: obj,
        newConfig: false,
        newConfigAttributes:false,
        newConfigClasses:false,
      });
    };

    if (event.target.files[0]) {
      reader.readAsText(event.target.files[0]);
    }
  }

  async changeConfig() {
    debugger
    if(this.props.algorithm === "FuzzyHoeffdingDecisionTree") {
      var error = false,
          errorUpdating = false;
      var response;
      var errorMessage = "Wrong attribute config, please check fields";

      for (var i = 0; i < this.state.config.attributes.length; i++) {
        if (this.state.errorsAttributeName[i] || errorUpdating) {
          error = true;

          errorMessage = this.state.errorsAttributeNameContent[i]
          break;
        }
        if (this.state.config.attributes[i].type === "numericAtt") {
          for (var j = 0; j < this.state.config.attributes[i].normalizedProperties.length; j++) {
            if ((this.state.errorsPropertyName[i] && this.state.errorsPropertyName[i][j]) || (this.state.errorsInterval[i] && this.state.errorsInterval[i][j])) {
              error = true;
              if (this.state.errorsPropertyNameContent[i] != null) {
                errorMessage = this.state.errorsPropertyNameContent[i];
              } else {
                errorMessage = this.props.language.labels[this.props.language.id].errorMessageInterval
              }
              break;
            }
          }
          if (error) {
            break;
          } else {
            response = await updateAttributeNormalizedConfig(
                this.props.dataset,
                this.state.config.attributes[i].id,
                this.state.config.attributes[i],
                this.props.language.id,
                this.props.token
            );

            if (response.error) {
              if (response.status === 401) {
                this.props.handleGlobalMessage(
                    "error",
                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                );
                this.props.closeSession();
                this.setState({
                  redirect: true
                });
              } else {
                errorUpdating = true;
                this.setState({
                  error: true,
                  message: response.data
                });
              }
            } else {
              this.setState({
                newConfig: true,
                newConfigAttributes:true,
              });
            }
          }
        } else {
          for (j = 0; j < this.state.config.attributes[i].normalizedProperties.length; j++) {
            if (this.state.errorsPropertyName[i] && this.state.errorsPropertyName[i][j]) {
              error = true;
              break;
            }
          }
          if (error) {
            break;
          } else {
            response = await updateCategoricAttributeConfig(
                this.props.dataset,
                this.state.config.attributes[i].id,
                this.state.config.attributes[i],
                this.props.language.id,
                this.props.token
            );

            if (response.error) {
              if (response.status === 401) {
                this.props.handleGlobalMessage(
                    "error",
                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                );
                this.props.closeSession();
                this.setState({
                  redirect: true
                });
              } else {
                errorUpdating = true;
                this.setState({
                  error: true,
                  message: response.data
                });
              }
            } else {
              this.setState({
                newConfig: true,
                newConfigAttributes:true,
              });
            }
          }
        }
      }
      for ( i = 0; i < this.state.config.consequents.length; i++) {
        if (this.state.errorsClassName[i] || errorUpdating) {
          error = true;
          errorMessage = this.state.errorsClassName[i]
          break;
        }else{
          response = await updateConsequentConfig(
              this.props.dataset,
              this.state.config.consequents[i].id,
              this.state.config.consequents[i],
              this.props.language.id,
              this.props.token
          );

          if (response.error) {
            if (response.status === 401) {
              this.props.handleGlobalMessage(
                  "error",
                  this.props.language.labels[this.props.language.id].errorMessageUnauthorized
              );
              this.props.closeSession();
              this.setState({
                redirect: true
              });
            } else {
              errorUpdating = true;
              this.setState({
                error: true,
                message: response.data
              });
            }
          } else {
            this.setState({
              newConfig: true,
              newConfigClasses:true,
            });
          }
        }
      }
      if (!error && this.props.algorithm !== "FURIA") {
        if (this.state.classifications) {
          this.classify();
        } else {
          this.props.getTree();
        }
        this.setState({
          success: true,
          message: "Config successfuly changed"
        });
      } else if (!error) {
        if (this.state.classifications) {
          this.classify();
        } else {
          this.props.getRules();
        }
        this.setState({
          success: true,
          message: "Config successfuly changed"
        });
      } else {
        this.setState({
          error,
          message: !errorUpdating
              ? errorMessage
              : response.data
        });
      }
    }else{
       error = false;
       errorUpdating = false;
       errorMessage = "Wrong attribute config, please check fields";

      for ( i = 0; i < this.state.config.attributes.length; i++) {
        if (this.state.errorsAttributeName[i] || errorUpdating) {
          error = true;

          errorMessage = this.state.errorsAttributeNameContent[i]
          break;
        }
        if (this.state.config.attributes[i].type === "numericAtt") {
          for ( j = 0; j < this.state.config.attributes[i].properties.length; j++) {
            if ((this.state.errorsPropertyName[i] && this.state.errorsPropertyName[i][j]) || (this.state.errorsInterval[i] && this.state.errorsInterval[i][j])) {
              error = true;
              if (this.state.errorsPropertyNameContent[i] != null) {
                errorMessage = this.state.errorsPropertyNameContent[i];
              } else {
                errorMessage = this.props.language.labels[this.props.language.id].errorMessageInterval
              }
              break;
            }
          }
          if (error) {
            break;
          } else {
            response = await updateAttributeConfig(
                this.props.dataset,
                this.state.config.attributes[i].id,
                this.state.config.attributes[i],
                this.props.language.id,
                this.props.token
            );

            if (response.error) {
              if (response.status === 401) {
                this.props.handleGlobalMessage(
                    "error",
                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                );
                this.props.closeSession();
                this.setState({
                  redirect: true
                });
              } else {
                errorUpdating = true;
                this.setState({
                  error: true,
                  message: response.data
                });
              }
            } else {
              this.setState({
                newConfig: true,
                newConfigAttributes:true,
              });
            }
          }
        } else {
          for (j = 0; j < this.state.config.attributes[i].properties.length; j++) {
            if (this.state.errorsPropertyName[i] && this.state.errorsPropertyName[i][j]) {
              error = true;
              break;
            }
          }
          if (error) {
            break;
          } else {
            response = await updateCategoricAttributeConfig(
                this.props.dataset,
                this.state.config.attributes[i].id,
                this.state.config.attributes[i],
                this.props.language.id,
                this.props.token
            );

            if (response.error) {
              if (response.status === 401) {
                this.props.handleGlobalMessage(
                    "error",
                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                );
                this.props.closeSession();
                this.setState({
                  redirect: true
                });
              } else {
                errorUpdating = true;
                this.setState({
                  error: true,
                  message: response.data
                });
              }
            } else {
              this.setState({
                newConfig: true,
                newConfigAttributes:true,
              });
            }
          }
        }
      }
      for ( i = 0; i < this.state.config.consequents.length; i++) {
        if (this.state.errorsClassName[i] || errorUpdating) {
          error = true;
          errorMessage = this.state.errorsClassName[i]
          break;
        }else{
          console.log(this.state.config.consequents)
          response = await updateConsequentConfig(
              this.props.dataset,
              this.state.config.consequents[i].id,
              this.state.config.consequents[i],
              this.props.language.id,
              this.props.token
          );

          if (response.error) {
            if (response.status === 401) {
              this.props.handleGlobalMessage(
                  "error",
                  this.props.language.labels[this.props.language.id].errorMessageUnauthorized
              );
              this.props.closeSession();
              this.setState({
                redirect: true
              });
            } else {
              errorUpdating = true;
              this.setState({
                error: true,
                message: response.data
              });
            }
          } else {
            this.setState({
              newConfig: true,
              newConfigClasses:true,
            });
          }
        }
      }
      if (!error && this.props.algorithm !== "FURIA") {
        if (this.state.classifications) {
          this.classify();
        } else {
          this.props.getTree();
        }
        this.setState({
          success: true,
          message: "Config successfuly changed"
        });
      } else if (!error) {
        if (this.state.classifications) {
          this.classify();
        } else {
          this.props.getRules();
        }
        this.setState({
          success: true,
          message: "Config successfuly changed"
        });
      } else {
        this.setState({
          error,
          message: !errorUpdating
              ? errorMessage
              : response.data
        });
      }

    }
  }

  async changeConfigClasses() {
    if(this.props.algorithm === "FuzzyHoeffdingDecisionTree") {
      var error = false,
          errorUpdating = false;
      var response;
      var errorMessage = "Wrong attribute config, please check fields";

      for (var i = 0; i < this.state.config.consequents.length; i++) {
        if (this.state.errorsClassName[i] || errorUpdating) {
          error = true;
          errorMessage = this.state.errorsClassName[i]
          break;
        }else{
          response = await updateConsequentConfig(
              this.props.dataset,
              this.state.config.consequents[i].id,
              this.state.config.consequents[i],
              this.props.language.id,
              this.props.token
          );

          if (response.error) {
            if (response.status === 401) {
              this.props.handleGlobalMessage(
                  "error",
                  this.props.language.labels[this.props.language.id].errorMessageUnauthorized
              );
              this.props.closeSession();
              this.setState({
                redirect: true
              });
            } else {
              errorUpdating = true;
              this.setState({
                error: true,
                message: response.data
              });
            }
          } else {
            this.setState({
              newConfig: true,
              newConfigClasses:true,
            });
          }
        }
      }
      if (!error && this.props.algorithm !== "FURIA") {
        if (this.state.classifications) {
          this.classify();
        } else {
          this.props.getTree();
        }
        this.setState({
          success: true,
          message: "Config successfuly changed"
        });
      } else if (!error) {
        if (this.state.classifications) {
          this.classify();
        } else {
          this.props.getRules();
        }
        this.setState({
          success: true,
          message: "Config successfuly changed"
        });
      } else {
        this.setState({
          error,
          message: !errorUpdating
              ? errorMessage
              : response.data
        });
      }
    }else{
       error = false;
       errorUpdating = false;
       errorMessage = "Wrong attribute config, please check fields";

      for ( i = 0; i < this.state.config.consequents.length; i++) {
        if (this.state.errorsClassName[i] || errorUpdating) {
          error = true;
          errorMessage = this.state.errorsClassName[i]
          break;
        }else{
          console.log(this.state.config.consequents)
          response = await updateConsequentConfig(
              this.props.dataset,
              this.state.config.consequents[i].id,
              this.state.config.consequents[i],
              this.props.language.id,
              this.props.token
          );

          if (response.error) {
            if (response.status === 401) {
              this.props.handleGlobalMessage(
                  "error",
                  this.props.language.labels[this.props.language.id].errorMessageUnauthorized
              );
              this.props.closeSession();
              this.setState({
                redirect: true
              });
            } else {
              errorUpdating = true;
              this.setState({
                error: true,
                message: response.data
              });
            }
          } else {
            this.setState({
              newConfig: true,
              newConfigClasses:true,
            });
          }
        }
      }
      if (!error && this.props.algorithm !== "FURIA") {
        if (this.state.classifications) {
          this.classify();
        } else {
          this.props.getTree();
        }
        this.setState({
          success: true,
          message: "Config successfuly changed"
        });
      } else if (!error) {
        if (this.state.classifications) {
          this.classify();
        } else {
          this.props.getRules();
        }
        this.setState({
          success: true,
          message: "Config successfuly changed"
        });
      } else {
        this.setState({
          error,
          message: !errorUpdating
              ? errorMessage
              : response.data
        });
      }

    }
  }


  async changeConfigAttributes() {
    debugger
    if(this.props.algorithm === "FuzzyHoeffdingDecisionTree") {
      var error = false,
          errorUpdating = false;
      var response;
      var errorMessage = "Wrong attribute config, please check fields";

      for (var i = 0; i < this.state.config.attributes.length; i++) {
        if (this.state.errorsAttributeName[i] || errorUpdating) {
          error = true;

          errorMessage = this.state.errorsAttributeNameContent[i]
          break;
        }
        if (this.state.config.attributes[i].type === "numericAtt") {
          for (var j = 0; j < this.state.config.attributes[i].normalizedProperties.length; j++) {
            if ((this.state.errorsPropertyName[i] && this.state.errorsPropertyName[i][j]) || (this.state.errorsInterval[i] && this.state.errorsInterval[i][j])) {
              error = true;
              if (this.state.errorsPropertyNameContent[i] != null) {
                errorMessage = this.state.errorsPropertyNameContent[i];
              } else {
                errorMessage = this.props.language.labels[this.props.language.id].errorMessageInterval
              }
              break;
            }
          }
          if (error) {
            break;
          } else {
            response = await updateAttributeNormalizedConfig(
                this.props.dataset,
                this.state.config.attributes[i].id,
                this.state.config.attributes[i],
                this.props.language.id,
                this.props.token
            );

            if (response.error) {
              if (response.status === 401) {
                this.props.handleGlobalMessage(
                    "error",
                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                );
                this.props.closeSession();
                this.setState({
                  redirect: true
                });
              } else {
                errorUpdating = true;
                this.setState({
                  error: true,
                  message: response.data
                });
              }
            } else {
              this.setState({
                newConfig: true,
                newConfigAttributes:true,
              });
            }
          }
        } else {
          for (j = 0; j < this.state.config.attributes[i].normalizedProperties.length; j++) {
            if (this.state.errorsPropertyName[i] && this.state.errorsPropertyName[i][j]) {
              error = true;
              break;
            }
          }
          if (error) {
            break;
          } else {
            response = await updateCategoricAttributeConfig(
                this.props.dataset,
                this.state.config.attributes[i].id,
                this.state.config.attributes[i],
                this.props.language.id,
                this.props.token
            );

            if (response.error) {
              if (response.status === 401) {
                this.props.handleGlobalMessage(
                    "error",
                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                );
                this.props.closeSession();
                this.setState({
                  redirect: true
                });
              } else {
                errorUpdating = true;
                this.setState({
                  error: true,
                  message: response.data
                });
              }
            } else {
              this.setState({
                newConfig: true,
                newConfigAttributes:true,
              });
            }
          }
        }
      }
        if (!error && this.props.algorithm !== "FURIA") {
        if (this.state.classifications) {
          this.classify();
        } else {
          this.props.getTree();
        }
        this.setState({
          success: true,
          message: "Config successfuly changed"
        });
      } else if (!error) {
        if (this.state.classifications) {
          this.classify();
        } else {
          this.props.getRules();
        }
        this.setState({
          success: true,
          message: "Config successfuly changed"
        });
      } else {
        this.setState({
          error,
          message: !errorUpdating
              ? errorMessage
              : response.data
        });
      }
    }else{
         error = false;
         errorUpdating = false;
         errorMessage = "Wrong attribute config, please check fields";

        for ( i = 0; i < this.state.config.attributes.length; i++) {
          if (this.state.errorsAttributeName[i] || errorUpdating) {
            error = true;

            errorMessage = this.state.errorsAttributeNameContent[i]
            break;
          }
          if (this.state.config.attributes[i].type === "numericAtt") {
            for ( j = 0; j < this.state.config.attributes[i].properties.length; j++) {
              if ((this.state.errorsPropertyName[i] && this.state.errorsPropertyName[i][j]) || (this.state.errorsInterval[i] && this.state.errorsInterval[i][j])) {
                error = true;
                if (this.state.errorsPropertyNameContent[i] != null) {
                  errorMessage = this.state.errorsPropertyNameContent[i];
                } else {
                  errorMessage = this.props.language.labels[this.props.language.id].errorMessageInterval
                }
                break;
              }
            }
            if (error) {
              break;
            } else {
              response = await updateAttributeConfig(
                  this.props.dataset,
                  this.state.config.attributes[i].id,
                  this.state.config.attributes[i],
                  this.props.language.id,
                  this.props.token
              );

              if (response.error) {
                if (response.status === 401) {
                  this.props.handleGlobalMessage(
                      "error",
                      this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                  );
                  this.props.closeSession();
                  this.setState({
                    redirect: true
                  });
                } else {
                  errorUpdating = true;
                  this.setState({
                    error: true,
                    message: response.data
                  });
                }
              } else {
                this.setState({
                  newConfig: true,
                  newConfigAttributes:true,
                });
              }
            }
          } else {
            for (j = 0; j < this.state.config.attributes[i].properties.length; j++) {
              if (this.state.errorsPropertyName[i] && this.state.errorsPropertyName[i][j]) {
                error = true;
                break;
              }
            }
            if (error) {
              break;
            } else {
              response = await updateCategoricAttributeConfig(
                  this.props.dataset,
                  this.state.config.attributes[i].id,
                  this.state.config.attributes[i],
                  this.props.language.id,
                  this.props.token
              );

              if (response.error) {
                if (response.status === 401) {
                  this.props.handleGlobalMessage(
                      "error",
                      this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                  );
                  this.props.closeSession();
                  this.setState({
                    redirect: true
                  });
                } else {
                  errorUpdating = true;
                  this.setState({
                    error: true,
                    message: response.data
                  });
                }
              } else {
                this.setState({
                  newConfig: true,
                  newConfigAttributes:true,
                });
              }
            }
          }
        }
        if (!error && this.props.algorithm !== "FURIA") {
          if (this.state.classifications) {
            this.classify();
          } else {
            this.props.getTree();
          }
          this.setState({
            success: true,
            message: "Config successfuly changed"
          });
        } else if (!error) {
          if (this.state.classifications) {
            this.classify();
          } else {
            this.props.getRules();
          }
          this.setState({
            success: true,
            message: "Config successfuly changed"
          });
        } else {
          this.setState({
            error,
            message: !errorUpdating
                ? errorMessage
                : response.data
          });
        }

    }
  }
  async downloadConfig() {
    var response = await downloadConfig(
      this.state.config.dataset,
      this.props.language.id,
      this.props.token
    );

    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
          "error",
          this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({
          redirect: true
        });
      } else {
        this.setState({
          error: true,
          message: response.data
        });
      }
    } else {
      var url = window.URL.createObjectURL(response);
      var tempLink = document.createElement("a");
      tempLink.href = url;
      tempLink.setAttribute("download", this.state.config.dataset + ".json");
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
    }
  }
  handleChangeSlider(event, value) {
    this.setState({ percentage: value });
  }

  async uploadTest(event) {
    var response = await uploadTest(
      this.state.config.dataset,
      event.target.files[0],
      this.props.token
    );

    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
          "error",
          this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({
          redirect: true
        });
      } else {
        this.setState({
          error: true,
          message: response.data
        });
      }
    } else {
      console.log('Hola estamos en la parte de subir un dataset de test')
      response = await getTest(this.props.dataset, this.props.token);
      if (response.error) {
        if (response.status === 401) {
          this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
          );
          this.props.closeSession();
          this.setState({
            redirect: true
          });
        } else {
          this.setState({
            error: true,
            message: response.data
          });
        }
      } else {
        const labelsTestInstances = response.data.lines.map(
          (instance, index) => ({
            value: index,
            label: "Instance " + (index + 1)
          }),
        );
        if(this.props.algorithm ==="FURIA" || this.props.algorithm === "FuzzyHoeffdingDecisionTree") {
          var responseFingrams = await buildFingramsTest(
              this.state.config.dataset,
              this.props.algorithm,
              this.props.token,
              this.props.language.id
          );
          if (responseFingrams.error) {
            if (responseFingrams.status === 401) {
              this.props.handleGlobalMessage(
                  "error",
                  this.props.language.labels[this.props.language.id].errorMessageUnauthorized
              );
              this.props.closeSession();
              this.setState({
                loading: false,
                redirect: true
              });
            } else {
              this.setState({
                loading: false,
                error: true,
                message: responseFingrams.data
              });
            }
          } else {
            this.props.handleGlobalMessage(
                "success",
                "Dataset " + this.state.name + " succesfully created"
            );
            this.setState(
                {
                  loading: false,
                  ready: true
                });
            this.props.getSvgFingramTest();
            this.props.getLogFingramsTest();
          }
        }
          this.setState({
            instancesTest: response.data.lines,
            instanceTestIndex: 0,
            labelsTestInstances,
            selectedTestInstance: labelsTestInstances[0],
            instance: {
              attributes: response.data.lines[0].attributes,
              solution: response.data.lines[0].solution
            }
          });
        this.props.getMatrix("test");
      }
    }
  }
  async changeLock()  {
    if(this.state.typeInstanceSelected === 0) {
      this.setState({
        typeInstanceSelected:1,
        instance: {
          attributes: this.state.instances[this.state.instanceIndex].attributes,
          solution: this.state.instances[this.state.instanceIndex].solution
        },
      })
    }else{
      if(!this.state.instancesTest===undefined && !this.state.instancesTest === null) {
        this.setState({
          typeInstanceSelected: 0,
          instance: {
            attributes: this.state.instancesTest[this.state.instanceTestIndex].attributes,
            solution: this.state.instancesTest[this.state.instanceTestIndex].solution
          },
        })
      }else{
        this.setState({
          typeInstanceSelected: 0,
        })
      }
    }
  }
  rowRender(key, index, isScrolling, isVisible, style) {
    console.log(index);
    return (
      <MenuItem key={index} value={index}>
        {"Instance " + (index + 1)}
      </MenuItem>
    );
  }
  handleChangePanel = panel => (event, expanded) => {
    if(panel === 0) {
      this.setState({
        expandedCero: !this.state.expandedCero
      });
    }else if(panel === 1){
      this.setState({
        expandedOne: !this.state.expandedOne
      });
    }else if (panel === 2){
      this.setState({
        expandedTwo: !this.state.expandedTwo
      });
    }else if (panel === 2){
      this.setState({
        expandedThree: !this.state.expandedThree
      });
    }

  };

  render() {
    const { classes } = this.props;

    if (this.state.config && this.state.instances && this.state.instance) {
      var sideList = (
        <div className={classes.sideBar}>
          <IconButton
              className={classes.close}
              onClick={this.toggleDrawer("left", false)}
          >
            <Close />
          </IconButton>
          <Typography variant="h3" component="h3">
            {this.state.config.dataset}
          </Typography>
          <ExpansionPanel
              className={classes.panel}
              expanded={this.state.expandedCero}
              onChange={this.handleChangePanel(0)}
          >
            <ExpansionPanelSummary expandIcon={<ExpandMore />}>

                <Typography variant="h6" color="primary"component="h6" className={classes.upper}>
                  <PanoramaFishEye />{" "}
                  {this.props.language.labels[this.props.language.id].data}
                </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails style={{display:"block"}}>
          <Paper>
            <div
              className={
                this.state.selected === "test"
                  ? classes.selected
                  : classes.selectDiv
              }
            >
              {this.state.typeInstanceSelected === 0 &&
              <IconButton onClick={this.changeLock} color="primary" component="span">
                <LockOpenIcon/>
              </IconButton>
              }{ this.state.typeInstanceSelected === 1 &&
            <IconButton onClick={this.changeLock} color="primary" component="span">
              <LockIcon/>
            </IconButton>
            }
              <Typography className={classes.selectLabel} variant="body1">
                {this.props.language.labels[this.props.language.id].test}:
              </Typography>
              {this.state.instancesTest && (
                <Select
                  disabled={this.state.typeInstanceSelected === 1}
                  className={classes.select}
                  options={this.state.labelsTestInstances}
                  value={this.state.selectedTestInstance}
                  onChange={this.handleChangeTest}
                />
              )}
              {!this.props.isDefault && (
                  <Button component="label" color="primary">
                    <CloudUpload />
                    <input
                      disabled={this.state.typeInstanceSelected === 1}
                      style={{ display: "none" }}
                      type="file"
                      onChange={this.uploadTest}
                    />
                  </Button>
                )}
            </div>
            <div
              className={
                this.state.selected === "train"
                  ? classes.selected
                  : classes.selectDiv
              }
            >
              {this.state.typeInstanceSelected === 1 &&
              <IconButton onClick={this.changeLock} color="primary" component="span">
                <LockOpenIcon/>
              </IconButton>
              }{ this.state.typeInstanceSelected === 0 &&
            <IconButton onClick={this.changeLock} color="primary" component="span">
              <LockIcon/>
            </IconButton>
            }
              <Typography className={classes.selectLabel} variant="body1">
                {this.props.language.labels[this.props.language.id].train}:
              </Typography>{" "}
              <Select
                disabled={this.state.typeInstanceSelected === 0}
                className={classes.select}
                options={this.state.labelsInstances}
                value={this.state.selectedInstance}
                onChange={this.handleChange}
              />
            </div>
          </Paper>
            </ExpansionPanelDetails>
          </ExpansionPanel>
          <ExpansionPanel
              className={classes.panel}
              expanded={this.state.expandedOne}
              onChange={this.handleChangePanel(1)}
          >
            <ExpansionPanelSummary expandIcon={<ExpandMore />}>
              <Typography variant="h6" color="primary"component="h6" className={classes.upper}>
                <PanoramaFishEye />{" "}
                {this.props.language.labels[this.props.language.id].attributes}
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails style={{display:"block"}}>
          {this.state.config.attributes.map((att, index) => {
            return (
              <Attribute
                key={index}
                att={att}
                algorithm = {this.props.algorithm}
                index={index}
                isDefault={this.props.isDefault}
                errorsAttributeName={this.state.errorsAttributeName}
                changeAttributeName={this.changeAttributeName}
                instance={this.state.instance}
                changeAttributeValue={this.changeAttributeValue}
                errorsInstance={this.state.errorsInstance}
                userInstance={this.state.userInstance}
                changeCategoricValue={this.changeCategoricValue}
                errorsPropertyName={this.state.errorsPropertyName}
                changePropertyName={this.changePropertyName}
                errorsInterval={this.state.errorsInterval}
                changeInterval={this.changeInterval}
                deleteInterval={this.deleteInterval}
                loadingButtonDelete={this.state.loadingButtonDelete}
                changeCategoricName={this.changeCategoricName}
                showNewInterval={this.showNewInterval}
              />
            );
          })}
              <ListItem>
                {!this.props.isDefault && (
                    <Button
                        disabled={this.state.newConfigAttributes}
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        onClick={this.changeConfigAttributes}
                    >
                      {this.props.language.labels[this.props.language.id].change}
                    </Button>
                )}
              </ListItem>
            </ExpansionPanelDetails >
          </ExpansionPanel>
          <ExpansionPanel
              className={classes.panel}
              expanded={this.state.expandedTwo}
              onChange={this.handleChangePanel(2)}
          >
            <ExpansionPanelSummary expandIcon={<ExpandMore />}>
              <Typography variant="h6"  color="primary"component="h6" className={classes.upper}>
                <PanoramaFishEye />{" "}
                {this.props.language.labels[this.props.language.id].classes}
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails style={{display:"block"}}>
              <Paper>
                <List>
                  {this.state.config.consequents.map((consequent, index) => {
                    return (
                      <Fragment>
                        <ListItem>
                          {this.props.isDefault ? (
                              <ListItemText primary={index + " : " + consequent.name} />

                          ) : (
                              <span>{index.toString() +" : "}
                              <Input
                                  className={classes.input}
                                  id={index.toString()}
                                  error={this.state.errorsClassName[index]}
                                  onChange={this.changeClassName}
                                  value={consequent.name}
                                  inputProps={{
                                    "aria-label": "Description"
                                  }}
                              />
                              </span>
                              )}
                        </ListItem>
                        <Divider />
                      </Fragment>
                    );
                  })}
                </List>
              </Paper>
              <ListItem>
                {!this.props.isDefault && (
                    <Button
                        disabled={this.state.newConfigClasses}
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        onClick={this.changeConfigClasses}
                    >
                      {this.props.language.labels[this.props.language.id].change}
                    </Button>
                )}
              </ListItem>
            </ExpansionPanelDetails>
          </ExpansionPanel>
          <ExpansionPanel
              className={classes.panel}
              expanded={this.state.expandedThree}
              onChange={this.handleChangePanel(3)}
          >
            <ExpansionPanelSummary expandIcon={<ExpandMore />}>
              <Typography variant="h6"  color="primary"component="h6" className={classes.upper}>
                <PanoramaFishEye />{" "}
                {this.props.language.labels[this.props.language.id].configurationMenu}
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails style={{display:"block"}}>
              <ListItem>
                <ListItemText
                    primary={
                      this.props.language.labels[this.props.language.id].tolerance
                    }
                    className={classes.sliderText}
                />
              </ListItem>
              <ListItem>
                <Slider
                    step={1}
                    value={this.state.percentage}
                    onChange={this.handleChangeSlider}
                />
                <Typography className={classes.percentage}>
                  {this.state.percentage}%
                </Typography>
              </ListItem>
              <ListItem>
                {!this.props.isDefault && (
                    <Button
                        disabled={this.state.newConfig}
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        onClick={this.changeConfig}
                    >
                      {this.props.language.labels[this.props.language.id].change}
                    </Button>
                )}
              </ListItem>
              <ListItem>
                {!this.props.isDefault && (
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        onClick={this.downloadConfig}
                    >
                      {this.props.language.labels[this.props.language.id].download}
                    </Button>
                )}
                {!this.props.isDefault && (
                    <Button
                        className={classes.button}
                        component="label"
                        variant="contained"
                        color="primary"
                    >
                      {
                        this.props.language.labels[this.props.language.id]
                            .uploadConfig
                      }
                      <input
                          style={{ display: "none" }}
                          type="file"
                          onChange={this.getFile}
                      />
                    </Button>
                )}
              </ListItem>
            </ExpansionPanelDetails>
          </ExpansionPanel>
          <ListItem>
            <Button
                variant="contained"
                color="primary"
                className={classes.button}
                onClick={this.classify}
            >
              {this.props.language.labels[this.props.language.id].classify}
            </Button>
          </ListItem>
          {this.state.messageRandomForest &&
              <div className={classes.plainLogBox}>
                <p>{this.state.messageRandomForest}</p>
              </div>
          }
        </div>
      );
    }

    return (
      !this.state.loading && (
        <div>
          <Button
            className={classes.buttonConfig}
            variant="contained"
            color="primary"
            onClick={this.toggleDrawer("left", true)}
          >
            <Menu />
          </Button>
          <div className={classes.configBar}>
            <Chip
              className={classes.chipDataset}
              color="primary"
              label={this.state.config.dataset}
            />
            <Chip
              className={classes.chipAttributes}
              color="primary"
              label={
                this.props.language.labels[this.props.language.id].attributes +
                ": " +
                this.state.config.attributes.length
              }
            />
            <Chip
              className={classes.chipConsequents}
              color="primary"
              label={
                this.props.language.labels[this.props.language.id].classes +
                ": " +
                this.state.config.consequents.length
              }
            />
            {this.props.percentage >= 80 && (
              <Chip
                className={classes.chipHigh}
                color="primary"
                icon={<High />}
                label={
                  this.props.language.labels[this.props.language.id].precision +
                  ": " +
                  this.props.percentage +
                  "%"
                }
              />
            )}
            {this.props.percentage >= 60 &&
              this.props.percentage < 80 && (
                <Chip
                  className={classes.chipMedium}
                  color="primary"
                  icon={<Medium />}
                  label={
                    this.props.language.labels[this.props.language.id]
                      .precision +
                    ": " +
                    this.props.percentage +
                    "%"
                  }
                />
              )}
            {this.props.percentage < 60 && (
              <Chip
                className={classes.chipLow}
                color="primary"
                icon={<Low />}
                label={
                  this.props.language.labels[this.props.language.id].precision +
                  ": " +
                  this.props.percentage +
                  "%"
                }
              />
            )}
          </div>
          <Drawer
            open={this.state.left}
            onClose={this.toggleDrawer("left", false)}
          >
            <div tabIndex={0} role="button">
              {sideList}
            </div>
          </Drawer>
          <CustomizedSnackbars
            openFail={this.state.error}
            openSuccess={this.state.success}
            handleClose={this.handleClose}
            message={this.state.message}
          />
          {this.state.redirect && <Redirect to="/" />}
        </div>
      )
    );
  }
}

ConfigurationPanel.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ConfigurationPanel);
